export function encodeToBase64<T>(data?: T): string | null {
  if (data === undefined || data === null) {
    return null;
  }

  try {
    const jsonString = JSON.stringify(data);
    return Buffer.from(jsonString, 'utf-8').toString('base64');
  } catch (error) {
    return null;
  }
}

export function decodeFromBase64<T>(encodedData?: string): T | null {
  if (!encodedData || typeof encodedData !== 'string') {
    return null;
  }

  try {
    const jsonString = Buffer.from(encodedData, 'base64').toString('utf-8');
    return JSON.parse(jsonString) as T;
  } catch (error) {
    return null;
  }
}
